// components/login-form/index
// форма авторизации

import Store    from 'Store'
import router   from 'router'
import template from './template.jade'
import style    from './style.scss'
import base64   from 'lib/base64'

var name = 'login-form'
var url = '/api/login'
const store = new Store(name)

export default {

  template: template({style: style}),

  data: () => ({
    name: name,
    url: url,
    disabled: false,
    store: store.data,
  }),

  methods: {
    submitForm (e) {
      e.preventDefault()
      var base64Hash = base64.encode(this.$get('login') + ':' + this.$get('password'))
      var headers = { Authorization: 'Basic ' + base64Hash }
      this.$set('headers', headers)
      this.$set('data', store.$get(this))
      this.$set('disabled', true)
      this.$once('fetchData:completed', () => this.$set('disabled', false))
    },
  },

  watch: {
    data() {
      // как только авторизовались, редирект
      if (store.validate()) {
        // сбросим пароль
        this.password = null
        // хак что бы подгрузить данные об авансовых платежах
        // для того что бы подгрузить сумму
        router.go({name: 'advance-info'})
        // еще подрузим настройки - для аватара
        router.go({name: 'settings'})
        //!!!

        // редирект по умолчанию при входе
        router.go({name: 'index'})
       /* location.reload()*/ /*Reload page*/
      }
    }
  },

}



/** WEBPACK FOOTER **
 ** ./src/js/components/login-form/index.js
 **/